import { render, staticRenderFns } from "./time-stamp.vue?vue&type=template&id=3926a3e9"
import script from "./time-stamp.vue?vue&type=script&lang=js"
export * from "./time-stamp.vue?vue&type=script&lang=js"
import style0 from "./time-stamp.vue?vue&type=style&index=0&id=3926a3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports